<template>
<div class="chapter">
<div class="inner_page">
<p class="fm-head">C<span class="small">ONTENTS</span></p>
<p class="TOC"><a href="#/Introduction">Introduction</a></p>
<p class="TOC1"><a href="#/Chapter1">Black History</a></p>
<p class="TOC"><span href="#/Chapter2" title="Link target outside of Sample">Business</span></p>
<p class="TOC"><span href="#/Chapter3" title="Link target outside of Sample">Disease</span></p>
<p class="TOC"><span href="#/Chapter4" title="Link target outside of Sample">Memorable Faces and Places</span></p>
<p class="TOC"><span href="#/Chapter5" title="Link target outside of Sample">Military</span></p>
<p class="TOC"><span href="#/Chapter6" title="Link target outside of Sample">Politics</span></p>
<p class="TOC"><span href="#/Chapter7" title="Link target outside of Sample">Sports</span></p>
<p class="TOC"><span href="#/Chapter8" title="Link target outside of Sample">Unforgettable Events</span></p>
<p class="TOC1"><span href="#/Author" title="Link target outside of Sample">About the Author</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Contents.vue?8af890d4